var xmlns = "http://www.w3.org/2000/svg";
var SELECTION_IDS = -1, MORE_MENU_ID = -2;
var DBL_CLICK_DELAY = 300;

var ENTITY_USER = 1, ENTITY_COMMUNITY = 2, ENTITY_TEAM = 3;


var WARNING_SHARE_LAYER = 1, WARNING_COPY_SHARE = 2, WARNING_DELETE_GROUPS = 4, WARNING_DELETE_CHECK_ITEM = 8,
    WARNING_LEAVE_COMMUNITY = 16, WARNING_ADD_POINT = 32, WARNING_SWAP_CHART = 64, WARNING_DELETE_CHART = 128,
    WARNING_DELETE_GRAPHIC_SINGLE = 256, WARNING_DELETE_GRAPHIC_MULTI = 512;

// globals for drag and drop
var dragObj = null, dragged = false;
var pointA = null, pointB = null, dx = 0, dy = 0;


var targetMap = null, activeTarget = null, targetLit = false;

// arrays for different groups of drop targets
var blockTargets = [];

var editObj = null; // reference to a object in edit state

var DEFAULT_ACTIVITY_COLOR = "#4435CC";
// colours array
var colours = ['#CC3333', '#CCC435', '#4435CC', '#CC6535', '#3ACC35', '#9F35CC', '#CC9735', '#35CC83', '#CC3597'];

if (!String.prototype.trim) String.prototype.trim = function () {
    return this.replace(/^\s+|&nbsp|\s+$/g, '');
};

if (!String.prototype.br) String.prototype.br = function () {
    return this.replace(/[\n\r]/g, '<br>');
};

if (!String.prototype.format) String.prototype.format = function () {
	var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) { 
      return typeof args[number-1] != 'undefined'
        ? args[number-1]
        : match;
    });
}

if (!Function.prototype.bind) Function.prototype.bind = function (oThis) {
    if (typeof this !== 'function') {
        throw new TypeError("Function.prototype.bind - need a function");
    }
    var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function () {
        },
        fBound = function () {
            return fToBind.apply(this instanceof fNOP && oThis
                    ? this : oThis,
                aArgs.concat(Array.prototype.slice.call(arguments)));
        };
    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();
    return fBound;
};

function ge(elem) {
    return (typeof(elem) === 'string') ? document.getElementById(elem) : elem;
}

function _(input) {
    return input;
}

function isEmpty(obj) {
	for(var prop in obj) {
		if(obj.hasOwnProperty(prop))
			return false;
	}

	return JSON.stringify(obj) === JSON.stringify({});
}

function icon(name, size, className) {
	let i = document.createElement('i');
	if (className) i.classList.add(className);
	i.classList.add('i-'+name);
	switch(size) {
		case 'sm': i.classList.add('i-sm'); return i;
		case 'lg': i.classList.add('i-lg'); return i;
		case 'xl': i.classList.add('i-xl'); return i;
		default: i.classList.add('i-rg'); return i;
	}
}

function div(className, content, events, attributes) {
	return htm.call(null, 'div', ...arguments);
}

function span(className, content, events, attributes) {
	return htm.call(null, 'span', ...arguments);
}

function p(eClass, eContent) {
	return htm.call(null, 'p', ...arguments);
}

function img(eClass, eSrc, eEvents, eAttributes) {
	return htm.call(null, 'img', ...arguments);
}

function btn(className, content, events, attributes) {
	let e = htm.call(null, 'button', ...arguments);
	e.type = 'button';
	return e;
}

function label(className, content, events, attributes) {
	return htm.call(null, 'label', ...arguments);
}

function text(className, value, events, attributes) {
	return input.call(null, 'text', ...arguments);
}

function area(className, value, events, attributes) {
	return htm.call(null, 'textarea', ...arguments);
}

function chk(className, value, events, attributes) {
	return input.call(null, 'checkbox', ...arguments);
}

function input(type, className, value, events, attributes) {
	let e = document.createElement('input');
	e.type = type;
	e.value = value;
	return htm(e, className, null, events, attributes);
}

function option(label, value) {
	let e = document.createElement('option');
	e.innerHTML = label;
	e.value = value;
	return e;
}

function htm(eType, eClass, eContent, eEvents, eAttributes) {
    let elem = typeof eType === 'string' ? document.createElement(eType) : eType;
    if (eClass) elem.className = eClass;
    if (eContent) {
		if (typeof eContent === 'string') {
            switch(eType) {
                case 'img':
                    elem.src = eContent;
                    break;
				case 'optgroup':
					elem.label = eContent;
                default:
                    elem.innerHTML = eContent;
            }
		}
        else if (Array.isArray(eContent)) {
            eContent.forEach(function(value){
				if (value != null) {
					if (typeof value === 'string'){
						this.innerHTML += value;
					}
					else if (typeof value === 'object') {
						this.appendChild(value);
					}
				}
			}, elem);
        }
        else if (typeof eContent === 'object') {
            elem.appendChild(eContent);
        }
    }
    if (eEvents) {
        for (var cb in eEvents)
            if (eEvents.hasOwnProperty(cb)) onEv(elem, cb, eEvents[cb]);
    }
    if (eAttributes) {
        for (var att in eAttributes)
            if (eAttributes.hasOwnProperty(att)) elem.setAttribute(att, eAttributes[att]);
    }
    return elem;
}

// TODO replace with BOOTSTRAP
function tCheck(lblOn, lblOff, chkBox, icon, text) {
	if (typeof chkBox === 'undefined' || chkBox === null) 
		chkBox = chk();
	if (typeof icon === 'undefined')
		icon = null;

	return label('switch', [
		span('desc', text || ''),
		chkBox,
		span('background', [
			span('switch-on', lblOn),
			span('switch-off', lblOff),
			span('switch-toggle', icon)
		])
	]);
}

function findPos(alignment, measureEl, targetEl, offset) {
	offset = offset ? offset : 0;
	let top, left, r;
	let mb = measureEl ? measureEl.getBoundingClientRect() : {width: 0, height:0};
	if (typeof alignment == 'undefined' || !alignment || typeof targetEl == 'undefined' || !targetEl) {
		return {
			top:0.3 * window.innerHeight - 0.5 * mb.height,
			left:0.5 * window.innerWidth - 0.5 * mb.width,
			rotation:0
		}
	}
	alignment = alignment.split('-');
	let A = alignment[0];
	let tb = targetEl.getBoundingClientRect();
	
	switch(alignment[0]) {
		case 'above':
			top = tb.top - mb.height - offset;
			r = 0;
			break;
		case 'left':
			left = tb.left - mb.width - offset;
			r = 270
			break;
		case 'right':
			left = tb.left + tb.width + offset;
			r = 90
			break;
		case 'below': default:
			top = tb.top + tb.height + offset;
			r = 180;
	}
	
	offset = offset * 2;

	switch (alignment.length > 1 ? alignment[1] : null) {
		case 'start':
			if (A == 'above' || A == 'below') {
				left = limit(tb.left, 5, window.innerWidth - mb.width - 5);
			}
			else {
				top = limit(tb.top, 5, window.innerHeight - mb.height - 5);
			}
			break;
		case 'end':
			if (A == 'above' || A == 'below') {
				left = limit(tb.left + tb.width - mb.width, 5, window.innerWidth - mb.width - 5);
			}
			else {
				top = limit(tb.top + tb.height - mb.height, 5, window.innerHeight - mb.height - 5);
			}
			break;
		case 'above':
			top = limit(tb.top - mb.height + offset, 5, window.innerHeight - mb.height - 5);
			break;
		case 'below':
			top = limit(tb.top + mb.height - offset, 5, window.innerHeight - mb.height - 5);
			break;
		case 'left':
			left = limit(tb.left - mb.width + offset, 5, window.innerWidth - mb.width - 5);
			break;
		case 'right':
			left = limit(tb.left + tb.width - offset, 5, window.innerWidth - mb.width - 5);
			break;
		default:
			if (A == 'above' || A == 'below') {
				left = limit(tb.left + 0.5 * tb.width - 0.5 * mb.width, 5, window.innerWidth - mb.width - 5);
			}
			else {
				top = limit(tb.top + 0.5 * tb.height - 0.5 * mb.height, 5, window.innerHeight - mb.height - 5);
			}
	}
	return {top: top, left: left, r: r};
}

function onEv(elem, ev, fnc) {
    elem = ge(elem);
	if (elem === null) return;
	
    ev = ev.split(/\s+/);
    if (elem.addEventListener) {
        for (var i = 0, ii = ev.length; i < ii; i++) {
            elem.addEventListener(ev[i], fnc, false);
        }
    }
    else if (elem.attachEvent) {
        for (var i = 0, ii = ev.length; i < ii; i++) {
            elem.attachEvent('on' + ev[i], fnc);
        }
    }
    else  {
        alert("Browser not supported");
    }
}

function remEv(elem, ev, fnc) {
	elem = ge(elem);
	if (elem === null) return;
	
    ev = ev.split(/\s+/);
    if (elem.addEventListener) {
        for (var i = 0, ii = ev.length; i < ii; i++) {
            elem.removeEventListener(ev[i], fnc, false);
        }
    }
    else if (elem.attachEvent) {
        for (var i = 0, ii = ev.length; i < ii; i++) {
            elem.detachEvent('on' + ev[i], fnc);
        }
    }
    else  {
        alert("Browser not supported");
    }
}

function progress(elem, type) {
    type = type || 'circle';
    var p = div('progress ' + type, '<p></p>');
    if (typeof(elem) !== 'undefined' && elem !== null) {
        ge(elem).appendChild(p);
        return true;
    } else {
        return p;
    }
}

/*function ne(elType, appendTo, elClass) {
    var el = document.createElement(elType);
    if (typeof(appendTo) === 'object' && appendTo !== null) appendTo.appendChild(el);
    if (typeof(elClass) === 'string') el.className = elClass;
    return el;
}*/

/**
 * @return {number}
 */
function ExNum(value) {
    var n = parseInt(value);
    return n === null || isNaN(n) ? 0 : n;
}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

onEv(window, 'load',
	function () {
		toastWindow = ge('toast-message');
		if (toastWindow !== null) nextToast();
	}
);
onEv(document, 'mouseup', stopSelectBlocking);

function toggleNavWidth() {
	var body = document.body;
	if (document.cookie.match(/nav-narrow=1/)) {
		body.className = body.className.replace(/nav-narrow/g, 'nav-wide');
		document.cookie = "nav-narrow=0;path=/";
	}
	else {
		body.className = body.className.replace(/nav-wide/g, 'nav-narrow');
		document.cookie = "nav-narrow=1;path=/";
	}
}

function loadHelpVideo(helpTopic) {
    helpTopic = helpTopic || 'OkJDOHwU0jg';
    state(ge('helpVideo'));
    ge('helpVideoFrame').src = 'https://youtube.com/embed/' + helpTopic + '?&autoplay=1&mute=0';
}

function unloadHelpVideo() {
    ge('helpVideoFrame').src = '';
    state(ge('helpVideo'), 'hide');
}

//noinspection JSUnusedGlobalSymbols
function tempId(length) {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
}

function ajaxData(formName) {
    // Todo - test this function for case sensitivity
    var form = document.forms[formName];
    if (!form || form.nodeName !== "FORM") return;

    var i, j, q = [];
    for (i = 0; i < form.elements.length; i++) {
        if (form.elements[i].name === "") {
            continue;
        }
        switch (form.elements[i].nodeName) {
            case 'INPUT':
                switch (form.elements[i].type) {
                    case 'text':
                    case 'hidden':
                    case 'password':
                    case 'button':
                    case 'reset':
                    case 'submit':
                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        break;
                    case 'checkbox':
                    case 'radio':
                        if (form.elements[i].checked) {
                            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        }
                        break;
                    default :
                }
                break;
            case 'file':
                break;
            case 'TEXTAREA':
                q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                break;
            case 'SELECT':
                switch (form.elements[i].type) {
                    case 'select-one':
                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        break;
                    case 'select-multiple':
                        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                            if (form.elements[i].options[j].selected) {
                                q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].options[j].value));
                            }
                        }
                        break;
                    default:
                }
                break;
            case 'BUTTON':
                switch (form.elements[i].type) {
                    case 'reset':
                    case 'submit':
                    case 'button':
                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        break;
                    default :
                }
                break;
            default :
        }
    }
    return q;
}

function getAjaxObject() {
    if (window.XMLHttpRequest) {
        return new XMLHttpRequest;
    } else {
        return new ActiveXObject("Microsoft.XMLHTTP");
    }
}

function ajp(ajaxFile, postData, sendTo, callback, callbackObj) {
    var ajax = getAjaxObject();
    ajax.open('POST', '/ajax/'+ajaxFile, true);
    ajax.onreadystatechange = function () {
        handleAjax(ajax, ge(sendTo), callback, callbackObj);
    };
    if (Array.isArray(postData)) {
        ajax.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        ajax.send(postData.join("&"));
    } else {
        ajax.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
        ajax.send(JSON.stringify(postData));
    }
}

function ajg(ajaxFile, getData, sendTo, callback, callbackObj) {
    var ajax = getAjaxObject();
    if (Array.isArray(getData) && getData.length) {
        ajax.open('GET', '/ajax/'+ajaxFile + '?' + getData.join('&'), true)
    } else if (typeof getData === 'object' && getData !== null) {
    	var getArray = [];
		for(var i in getData) {
			if (getData.hasOwnProperty(i) && getData[i] !== null)
				getArray.push(encodeURI(i + '=' + getData[i]));
		}
		ajax.open('GET', '/ajax/'+ajaxFile + '?' + getArray.join('&'), true);
	} else {
        ajax.open('GET', '/ajax/'+ajaxFile, true);
    }
    ajax.onreadystatechange = function () {
        handleAjax(ajax, ge(sendTo), callback, callbackObj);
    };
    ajax.send();
}

function handleAjax(ajax, sendTo, callback, callbackObj) {
	if (ajax.status !== 200) return;
    if (ajax.readyState === 4) {
        if (sendTo) {
            sendTo.innerHTML = ajax.responseText;
            //if (ge('afterLoad')) eval(ge('afterLoad').innerHTML);
            if (typeof(callbackObj) !== 'undefined') {
                callback.call(callbackObj);
            } else if (typeof(callback) !== 'undefined') {
                callback();
            }
        } else {
            var reply = JSON.parse(ajax.responseText);
            if (typeof(callbackObj) !== 'undefined') {
                callback.call(callbackObj, reply);
            } else if (typeof(callback) !== 'undefined') {
                callback(reply);
            }
        }
    }
}

function showError(reply){
	if (reply.error) {
		makeToast(reply.error);
		return true;
	}
	return false;
}

function loadHTML(reply, elem) {
    if (reply.html){
        ge(elem).innerHTML = reply.html;
        return true;
    }
    return false;
}

function point(ev) {
	var x, y;
	x = !!ev.touches ? ev.touches[0].clientX : ev.clientX;
	y = !!ev.touches ? ev.touches[0].clientY : ev.clientY;
	return {x: x, y: y};
}

function limit(val, min, max) {
    if (min !== null && val < min) return min;
    if (max !== null && max < val) return max;
    return val;
}

function dragging() {
    return dragObj !== null;
}

function setDragTargets(targets, ignore) {
	targetMap = [];
    for (let target of targets) {
		if (ignore.indexOf(target) === -1) targetMap.push(target);
    }
}

function startDrag(ev, obj) {
    if (dragging()) return;

    ev.preventDefault();

    dragObj = obj;
    pointA = pointB = point(ev);

    onEv(document, 'mousemove touchmove', drag);
	onEv(document, 'mouseup touchend', stopDrag);

	startSelectBlocking();
	return false;
}

function startSelectBlocking() {
    document.body.focus(); // clear any selected text
    document.onselectstart = function () {
        return false;
    }; //prevent text selection
    document.ondragstart = function () {
        return false;
    }; //prevent image dragging
}

function stopSelectBlocking() {
    document.onselectstart = null;
    document.ondragstart = null;
}

function drag(ev) {
    pointB = point(ev);
    dx = pointB.x - pointA.x;
    dy = pointB.y - pointA.y;

    if (dx > 2 || dx < -2 || dy > 2 || dy < -2) dragged = true;

    if (!dragged) return;
    
	checkTargets();

    if (dragObj.drag) dragObj.drag(ev);
}

function checkTargets() {
    if (targetMap === null) return null;
	for (target of targetMap) {
		if (
			target.box.top < pointB.y && pointB.y < target.box.bottom &&
			target.box.left < pointB.x && pointB.x < target.box.right
		) {
			if (activeTarget == target) return target;
			if (activeTarget) activeTarget.target = false;
			activeTarget = target;
			activeTarget.target = true;
			return;
		}
	}
	if (activeTarget) {
		activeTarget.target = false;
		activeTarget = null;
	}
    return null;
}

function stopDrag(ev) {
    if (dragging()) {
        if (dragged && dragObj.dropped) {
            dragObj.dropped(ev);
        }
        if (!dragged && dragObj.clicked) {
            dragObj.clicked(ev);
        }
    }
	dragged = false;
	if (activeTarget) {
		activeTarget.target = false;
		activeTarget = null;
	}
    dragObj = null;
    if (document.removeEventListener) {
        document.removeEventListener('mousemove', drag);
        document.removeEventListener('touchmove', drag);
    }
    else {
        document.detachEvent('onmousemove', drag);
        document.detachEvent('ontouchmove', drag);
    }
}

function pointInElem(elem, point) {
    point = typeof(point) === 'undefined' ? pointB : point;
    let pt = elem.getBoundingClientRect();
    return {x: (point.x - pt.x), y: (point.y - pt.y)};
}

function stopEv(ev) {
    if (ev.stopPropagation) {
        ev.stopPropagation();
    } else {
        ev.cancelBubble = true;
    }
}

// TODO replace with new 'mode' function
/** @deprecated */
function style(div, state) {
    div = ge(div);
    state = state || 'norm';
    div.className = div.className.replace(/[^\S](norm|disp|edit|loading|hide|drag|hiLt|warn|onTarget|move|open|close)[^\S]|[^\S](norm|disp|edit|loading|hide|drag|hiLt|warn|onTarget|move|open|close)$/g, ' ' + state + ' ');
}

function state(node, value) {
	let mode = value || 'norm';
	node.className = node.className.replace(/(^|\s+)(norm|hide|drag|glow|loading|warn|move|collapsed|fixed|active)(?=\s+|$)/gm, '$1'+mode);
}

/**
 *
 * @param msg string
 * @param parts array
 */
function buildMessage(msg, parts) {
    return msg.replace(/{(\d+)}/gi, function(match, num) {
        if (num <= parts.length) {
            return parts[num-1];
        }
        return match;
    })
}

let showMobilNav = false;
function toggleMobileNav() {
	showMobilNav = !showMobilNav;
	let button = ge('mobile-nav-button');
	let nav = ge('nav-view');
	state(button, showMobilNav ? 'active' : 'norm');
	state(nav, showMobilNav ? 'active' : 'norm');
}

function toggleMobileMenu() {
	showMobilNav = !showMobilNav;
	let button = ge('mobile-menu-button');
	let menu = ge('main-menu');
	state(button, showMobilNav ? 'active' : 'norm');
	state(menu, showMobilNav ? 'active' : 'norm');
}

// function toggleAccountMenu(elem) {
// 	let state = getCookie('acc-menu') || 'closed';
// 	document.cookie = state === 'closed' ? 'acc-menu=open;path=/' : 'acc-menu=closed;path=/';
// 	toggleCollapsible(elem);
// }

function toggleCollapsible(elem){
    var maxDepth = 6;
    while (maxDepth > 0){
        if (elem.className.match(/collapsible open/g)){
            elem.className = elem.className.replace(/ open/g, ' closed');
            break;
        }
        if (elem.className.match(/collapsible closed/g)){
            elem.className = elem.className.replace(/ closed/g, ' open');
            break;
        }
        if (elem.parentNode) elem = elem.parentNode;
        else break;
        maxDepth --;
    }
}

function toggleBtn(btn) {
    if (typeof(btn) === 'undefined') return false;
    if (btn.value === '1') {
        btn.className = btn.className.replace(/ on/g, " off");
        btn.value = 0;
    } else {
        btn.className = btn.className.replace(/ off/g, " on");
        btn.value = 1;
    }
    return parseInt(btn.value);
}

// usage -> category list on admin page.
function toggleList(button) {
    var parentElem = button;
    while (parentElem.parentNode){
        parentElem = parentElem.parentNode;
        if (parentElem.className.match(/ expanded/g)) {
            parentElem.className = parentElem.className.replace(/ expanded/g, " colapsed");
            button.innerHTML = '+';
            break;
        }
        if (parentElem.className.match(/ colapsed/g)) {
            parentElem.className = parentElem.className.replace(/ colapsed/g, " expanded");
            button.innerHTML = '-';
            break;
        }
    }
}
function isDark($bgColor) {
    // returns a value to indicate a when a light color is needed
    // ie. when a dark bg color is provided
    // if bg color can't be evaluated return false;
    var values = /^#?([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i.exec($bgColor);
    if (values && values.length === 4) {
        return ((parseInt(values[1], 16)  * 0.299) +
            (parseInt(values[2], 16)  * 0.587) +
            (parseInt(values[3], 16) * 0.114)) < 150;
    }
    else {
        return false;
    }
}

function getContrastColor(backgroundColor) {
    return isDark(backgroundColor) ? "WHITE" : "BLACK";
}

function getCookie(name) {
    name = name + '=';
    var cookies = decodeURIComponent(document.cookie).split(';');
    for (var i = 0, ii = cookies.length; i < ii; i++){
        var c = cookies[i];
        while(c.charAt(0) === " ") c = c.substring(1);
        if (c.indexOf(name) === 0) {
            return c.substring(name.length);
        }
    }
    return null;
}

function graphicSrc(id, size) {
	if (id == null) return '/images/lighten50.png';

	size = size || AC.GRAPHIC_LRG;
	let version = getCookie('g_id') || 0;
    return '/graphic/' + id + '/' + version + '?size=' + size;
}

function daySelect(suffix) {
    if (typeof(suffix) === 'undefined' || suffix === null) suffix = true;
    var s = '';
    for (var i = 1; i <= 31; i++) {
        if (suffix)
            s += '<option value="' + i + '">' + numSuffix(i) + '</option>\n';
        else
            s += '<option value="' + i + '">' + i + '</option>\n';
    }
    return s;
}
function numSuffix(i) {
    return i + (i === 11 || i === 12 || i === 13 ? 'th' : i % 10 === 1 ? 'st' : i % 10 === 2 ? 'nd' : i % 10 === 3 ? 'rd' : 'th');
}

/**
 * @return {string}
 */
function AmPm(h) {
    if (h === 0 || h === 24) return "12:00am";
    if (h === 12) return "12:00pm";
    if (h > 12) return (h - 12) + ":00pm";
    return h + ":00am";
}

/**
 * @return {string}
 */
function MinsPast(h, m) {
    if (m < 10) m = '0' + m;
    if (h === 0 || h === 24) return "12:" + m + "am";
    if (h === 12) return "12:" + m + "pm";
    if (h > 12) return (h - 12) + ":" + m + "pm";
    return h + ":" + m + "am";

}

function timeAgo(dateStamp) {
	let now = new Date();
	let eventTime = new Date(dateStamp.replace(/-/g, '/'));

	let secondsAgo = Math.floor((now - eventTime) / 1000);

	if (secondsAgo < 60) {
		return _("Just now");
	}
	
	let x = Math.floor(secondsAgo / 60);
	if (x < 60) {
		return x + " " + (1 < x ? _("minutes ago") : _("minute ago"));
	}

	x = Math.floor(x / 60);
	if (x < 24) {
		return x + " " + (1 < x ? _("hours ago") : _("hour ago"));
	}

	x = Math.floor(x / 24);
	if (x < 6) {
		let yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
		if (eventTime.getDate() === yesterday.getDate()){
			return _("Yesterday");
		}
		return App.WEEKDAY[eventTime.getDay()];
	}
	
	if (now.getFullYear() === eventTime.getFullYear()) {
		return numSuffix(eventTime.getDate()) + " " + App.MONTH[eventTime.getMonth()];
	}
	return numSuffix(eventTime.getDate()) + " " + App.MONTH[eventTime.getMonth()] + " " + eventTime.getFullYear();
	
}

//noinspection JSUnusedGlobalSymbols
function monthSelect() {
    var s = '';
    for (var i = 0; i < 12; i++) {
        s += '<option value="' + i + '">' + App.MONTH[i] + '</option>\n';
    }
    return s;
}

//noinspection JSUnusedGlobalSymbols
function weekSelect() {
    var s = '';
    for (var i = 0; i < 5; i++) {
        s += '<option value="' + i + '">' + App.WEEK[i] + '</option>\n';
    }
    return s;
}

//noinspection JSUnusedGlobalSymbols
function weekdaySelect() {
    var s = '';
    for (var i = 0; i < 7; i++) {
        s += '<option value="' + i + '">' + App.WEEKDAY[i] + '</option>\n';
    }
    return s;
}

function isLeapYear(y) {
    return (((y % 4 === 0) && (y % 100 !== 0)) || (y % 400 === 0));
}

function daysInMonth(y, m) {
    return [31, (isLeapYear(y) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m]
}

function getFirstDay(y, m) {
    let date = new Date(y, m, 1);
    return date.getDay();
}

function rads2degs(rads) {
	return rads * 180 / Math.PI;
}

function degs2rads(degs) {
	return degs * Math.PI / 180;
}

function polar2cart(dist, angle) {
	return {
		'x': dist * Math.cos(degs2rads(angle)),
		'y': dist * Math.sin(degs2rads(angle))
	};
}

function cart2polar(x, y) {
	return {
		'r': Math.sqrt(Math.pow(x,2) + Math.pow(y,2)),
		'a': rads2degs(Math.atan2(y,x))
	};
}

// TODO move this function some where - maybe a card class
function gridArray(items, boxHeight, boxWidth) {
    if (typeof(items) === 'undefined') return false;
    items = parseInt(items);
    if (isNaN(items)) return false;

    var rows = Math.round(Math.sqrt(items) * 0.65) || 1;
    var cols = Math.ceil(items / rows);

    var vSpace = boxHeight / (rows + 1);
    var hSpace = boxWidth / (cols + 1);
    var size = Math.floor((vSpace < hSpace ? vSpace : hSpace) * 0.95);

    var out = [size];
    var r, c;
    for (r = 1; r <= rows; r++) {
        if (r === rows) {
            cols = items % cols || cols;
            hSpace = boxWidth / (cols + 1);
        }
        c = 1;
        while (c <= cols) {
            out.push({
                'top': vSpace * r,
                'left': hSpace * c
            });
            c++;
        }
    }
    return out;
}

var toastTimeout, toastUp = true, toastMsgs = [];
var toastWindow;
function makeToast(msg) {
    if (toastUp) {
        // current message active que this one
        toastMsgs.push(msg);
    } else if (toastWindow) {
        toastUp = true;
        toastWindow.innerHTML = '<p>' + msg + '</p>';
        showToast();
    }
}

function showToast() {
    toastWindow.className = 'open';
    toastTimeout = setTimeout(hideToast, 4000);
}

function hideToast() {
    toastWindow.className = 'closing';
    toastTimeout = setTimeout(nextToast, 500);
}

function nextToast(){
    toastWindow.className = 'closed';
    toastUp = false;
    if (toastMsgs.length){
        makeToast(toastMsgs.shift());
    }
}

/* function steppedButtonClick(button, maxSteps, ev){
    
    var width = button.offsetWidth;
    var x = pointInElem(button, point(ev)).x;
    return Math.ceil(maxSteps / width * x);
} */

/* function sharingButtonClick(button, ev){
	

	var shareBtns = document.getElementsByName('sharing');
	var userId = button.getAttribute('data-user');
	var newVal = 1;
	for (i=1, ii = steppedButtonClick(button, 3, ev); i<ii; i++){
		newVal = newVal << 1;
	}
	var prevVal = parseInt(button.getAttribute('data-prev'));
	var currVal = parseInt(button.value);

	if (newVal === currVal)
		newVal = prevVal;
	var i, ii;
	for (i = 0, ii = shareBtns.length; i<ii; i++){
		if (shareBtns[i].getAttribute('data-user') === userId)
			shareBtns[i].value = newVal;
	}
//			setGroupHeaders();
} */

/* var filterCBs;
function onFilterChange(checkbox){
    var a, aa, result = 0;
    if (parseInt(checkbox.value) === -1) {
        if (checkbox.checked) {
            for (a = 0, aa = filterCBs.length; a < aa; a++){
                if (parseInt(filterCBs[a].value) === -1) continue;
                filterCBs[a].checked = false;
            }
        }
        else checkbox.checked = true;
    }
    else {
		var allBox;
		for (a = 0, aa = filterCBs.length; a < aa; a++) {
			if (parseInt(filterCBs[a].value) === -1) {
				allBox = filterCBs[a];
				continue;
			}
			if (filterCBs[a].checked) result += parseInt(filterCBs[a].value);
		}
		allBox.checked = result === 0;
    }
    afterFiltersChange(result);
} */

/* var tagCBs;
function onTagFilterChange(checkbox) {
	var a, aa, result = '';
	if (parseInt(checkbox.value) === -1) {
		if (checkbox.checked) {
			for (a = 0, aa = tagCBs.length; a < aa; a++){
				if (parseInt(tagCBs[a].value) === -1) continue;
				tagCBs[a].checked = false;
			}
		}
		else checkbox.checked = true;
	}
	else {
		var allBox;
		for (a = 0, aa = tagCBs.length; a < aa; a++) {
			if (parseInt(tagCBs[a].value) === -1) {
				allBox = tagCBs[a];
				continue;
			}
			if (tagCBs[a].checked) result += ',' + tagCBs[a].value;
		}
		if (result.length > 0) result = result.substring(1);
		allBox.checked = result.length === 0;
	}
	afterTagsChange(result);
} */
